import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const CalculatorIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                stroke="currentColor"
                d="m8.75 17.75-2.5-2.5M6.25 17.75l2.5-2.5M7.5 7v3M9 8.5H6M14 8.5h3M14 17.5h3M14 15.5h3M11.5 4.5v16M3.5 12.5h16"
            />
            <rect width={16} height={16} x={3.5} y={4.5} stroke="currentColor" rx={1.5} />
        </svg>
    </IconWrapper>
)
